import * as c from '../svgs';


export const skillsMappedToSvg = {
  MongoDB: c.Mongodb,
  Firebase: c.Firebase,
  GraphQL: c.Graphql,
  Cloudinary: c.Cloud,
  Node: c.Node,
  Express: c.Express,
  Mongoose: c.Mongoose,
  Docker: c.Docker,
  TravisCI: c.Travis,
  CircleCI: c.CircleCI,
  AWSElasticBeanstalk: c.Elastic,
  Git: c.Git,
  Blender: c.Blender,
  zBrush: c.Zbrush,
  Wordpress: c.Wordpress,
  'Chemical Engineering': c.Chemical,
  React: c.Reacts,
  'Redux-Toolkit': c.Redux,
  Next: c.Next,
  EJS: c.Ejs,
  Gatsby: c.Gatby,
  Typescript: c.Typescript,
  Javascript: c.Javascript,
  HTML5: c.Html,
  CSS3: c.Css,
  Figma: c.Figma,
  Bootstrap: c.Bootstrap,
  Tailwind: c.Tailwind,
  'Styled-components': c.StyledComp,
  ChakraUI: c.ChakraUi,
  SemanticUI: c.Semantic,
  'React-Spring': c.Spring,
}